<template>
  <div v-if="hasRequest" class="cancel-section mt-2">
    <div class="px-2">
      <p class="cancel-section-title">Cancellation Request</p>
    </div>
    <div class="section-card cancel-card">

      <div v-if="reason" class="cancel-reason">
        <p class="cancel-reason-label">Reason</p>
        <p class="cancel-reason-text">{{ reason }}</p>
      </div>

      <div class="cancel-actions">
        <AppButtonFlat
          block
          color="error"
          prepend-icon="mdi-cog-outline"
          @click="handleOpenActionModal"
        >
          Review cancellation
        </AppButtonFlat>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import AppointmentCancellationActionModal from "@/modules/vendor/components/AppointmentCancellationActionModal.vue";

const props = defineProps<{
  appointment: {
    cancellation_request?: {
      is_requested: boolean;
      reason: string | null;
    } | null;
  } | null;
}>();

const modal = useModalStore();
const hasRequest = computed(() => Boolean(props.appointment?.cancellation_request?.is_requested));
const reason = computed(() => props.appointment?.cancellation_request?.reason || "");

function handleOpenActionModal() {
  modal.open(
    AppointmentCancellationActionModal,
    {
      appointment: props.appointment,
    },
    { title: "Cancellation Options", showHeader: false, fullscreen: true },
  );
}
</script>

<style scoped>
.cancel-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cancel-section-title {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #6b7280;
}

.section-card {
  background: #fff;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.cancel-card {
  gap: 12px;
  border-color: #fecaca;
  background: #fffaf7;
  border-radius: 18px;
}

.cancel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.cancel-title-wrap {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.cancel-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: #fee2e2;
  color: #dc2626;
  flex-shrink: 0;
}

.cancel-subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.4;
}

.cancel-reason {
  border-radius: 12px;
}

.cancel-reason-label {
  margin: 0;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #b91c1c;
}

.cancel-reason-text {
  margin: 6px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  line-height: 1.5;
}

.cancel-actions {
  margin-top: 2px;
}
</style>
